import { render, staticRenderFns } from "./serviceAgree.vue?vue&type=template&id=f61ace7c&scoped=true"
import script from "./serviceAgree.vue?vue&type=script&lang=ts"
export * from "./serviceAgree.vue?vue&type=script&lang=ts"
import style0 from "./serviceAgree.vue?vue&type=style&index=0&id=f61ace7c&prod&lang=css"
import style1 from "./serviceAgree.vue?vue&type=style&index=1&id=f61ace7c&prod&scoped=true&lang=stylus&rel=stylesheet%2Fstylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f61ace7c",
  null
  
)

export default component.exports